<template>
  <form @submit.prevent="handleSave" class="lgpd-termo-form" data-testid="lgpd-termo-form">
    <div class="form-grid">
      <div class="form-group">
        <label class="form-label">{{ t('Título') }} *</label>
        <input-text
          v-model="formData.titulo"
          elem-id="lgpd_titulo"
          :required="true"
          :placeholder="t('Ex: Termo de Consentimento LGPD')"
          data-testid="lgpd-termo-form-titulo"
        />
      </div>

      <div class="form-group">
        <label class="form-label">{{ t('Versão') }} *</label>
        <input-text
          v-model="formData.versao"
          elem-id="lgpd_versao"
          :required="true"
          :placeholder="t('Ex: 1.0')"
          data-testid="lgpd-termo-form-versao"
        />
      </div>

      <div class="form-group form-group-full">
        <label class="form-label">{{ t('Conteúdo') }} *</label>
        <InputRichText
          v-model="formData.conteudo"
          data-testid="lgpd-termo-form-conteudo"
        />
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import InputText from '../../inputs/InputText.vue';

interface LgpdTermoFormData {
  titulo: string;
  versao: string;
  conteudo: string;
}

const { t } = useI18n();

// Vue 3.4+ two-way binding macro. The bound ref is `formData`; every
// child v-model="formData.X" mutation propagates back to the parent's
// v-model target automatically — no manual emit needed.
const formData = defineModel<LgpdTermoFormData>({
  default: () => ({ titulo: '', versao: '', conteudo: '' }),
});

const emit = defineEmits<{
  save: [data: LgpdTermoFormData];
}>();

const handleSave = (): void => {
  if (!formData.value.titulo.trim() || !formData.value.versao.trim() || !formData.value.conteudo.trim()) {
    return;
  }
  emit('save', { ...formData.value });
};
</script>

<style scoped>
.lgpd-termo-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group-full {
  grid-column: 1 / -1;
}

.form-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.form-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
}

.form-textarea:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.15);
}
</style>
